export default "__VITE_ASSET__C3EyelpT__"